import { PaddleSubscription, PlanDetails } from '../../types/paddle';
import { IntervalEnum } from '../../enum/intervalEnum';

export const transformSubscriptionToPlanDetails = (
  subscription: PaddleSubscription | any,
  seats: number
): PlanDetails => {
  const paddleData = subscription?.data || subscription || {};
  const firstItem = paddleData?.items?.[0] || {};
  const price = firstItem.price || {};
  const product = firstItem.product || {};

  return {
    id: paddleData?.id || '',
    status: paddleData?.status || '',
    interval: paddleData?.billing_cycle?.interval || IntervalEnum.MONTH,
    customer_id: paddleData?.customer_id || '',
    name: product?.name || price?.name || '',
    seats: seats || 1,
    price: price?.unit_price?.amount ?? price?.unitPrice?.amount ?? '0',
    currency:
      price?.unit_price?.currency_code ??
      price?.unitPrice?.currencyCode ??
      paddleData?.currency_code ??
      'USD',
    first_billed_at: paddleData?.first_billed_at || '',
    next_billed_at: paddleData?.next_billed_at || '',
    current_billing_period_ends_at:
      paddleData?.current_billing_period?.ends_at || '',
    scheduled_change: paddleData?.scheduled_change || null,
    management_urls: paddleData?.management_urls || null,
  };
};
